import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import Card from 'components/core/Card';
import { ContainedButton } from 'components/core/Button';

const CheckoutExitChoice = ({ onDefinitiveExit, onTemporaryExit }) => (
  <Card>
    <div className="row">
      {/* DEFINITIVE EXIT */}
      <div className="col-12 text-center mb-3 checkoutCardTitle">
        <LocalizedMessage id="info.checkoutDefinitiveExit" />
      </div>
      <div className="col-12 text-center my-3">
        <ContainedButton label={<LocalizedMessage id="button.definitiveExit" />} onClick={() => onDefinitiveExit()} />
      </div>

      {/* TEMPORARY EXIT */}
      <div className="col-12 text-center my-3 checkoutCardTitle">
        <LocalizedMessage id="info.checkoutTemporaryExit" />
      </div>
      <div className="col-12 text-center mt-3">
        <ContainedButton label={<LocalizedMessage id="button.temporaryExit" />} onClick={() => onTemporaryExit()} />
      </div>
    </div>
  </Card>
);

CheckoutExitChoice.propTypes = {
  onDefinitiveExit: PropTypes.func.isRequired,
  onTemporaryExit: PropTypes.func.isRequired,
};

module.exports = CheckoutExitChoice;



// WEBPACK FOOTER //
// ./routes/checkout/components/CheckoutExitChoice.js